import { HelpCircle, ThumbsDown, ThumbsUp } from 'lucide-react';
import type { DecisionPoint as IDecisionPoint } from '~/lib/feature-modules/types';

interface Props {
  point: IDecisionPoint;
}

export default function DecisionPoint({ point }: Props) {
  return (
    <div className="border border-indigo-100 rounded-xl p-4 bg-indigo-50/40">
      <div className="flex items-start gap-2 mb-3">
        <HelpCircle className="h-4 w-4 text-indigo-500 mt-0.5 flex-shrink-0" />
        <p className="text-sm font-medium text-indigo-900">{point.question}</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="flex items-start gap-2 p-2.5 bg-white rounded-lg border border-emerald-100">
          <ThumbsUp className="h-4 w-4 text-emerald-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs font-medium text-emerald-700 mb-0.5">
              If yes
            </p>
            <p className="text-xs text-gray-700">{point.ifYes}</p>
          </div>
        </div>
        <div className="flex items-start gap-2 p-2.5 bg-white rounded-lg border border-gray-100">
          <ThumbsDown className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs font-medium text-gray-500 mb-0.5">If no</p>
            <p className="text-xs text-gray-700">{point.ifNo}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
